var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAdditionRed = function SvgAdditionRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 24C5.376 23.993.007 18.624 0 12v-.24C.132 5.165 5.562-.086 12.158.001 18.754.09 24.043 5.483 24 12.078 23.957 18.674 18.598 23.998 12 24Zm-6-13.2v2.4h4.8V18h2.4v-4.8h4.8v-2.4h-4.8V6h-2.4v4.8h-4.8Z",
    fill: "#AD3F4C"
  })));
};
export default SvgAdditionRed;